import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../EnvVar';
import Cookies from 'js-cookie';
import axios from "axios"
import { Link } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";

function SocialMedia() {
    // js for modal first
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // js for modal first

    // js for modal second
    const [covshow, setCovshow] = useState(false);
    const covHandleClose = () => setCovshow(false);
    const covHandleShow = () => setCovshow(true);
    // js for modal second
    const [triggerEffect, setTriggerEffect] = useState(false)
    const baseURL = EvnVar()

    // Social Media APIs
    // Get API
    const token = Cookies.get("jwt")
    const [eventData, setEventData] = useState([])
    useEffect(() => {
        // console.log("token social media", token);
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/socialmedia`,
            headers: {
                Authorization: token,
            },
            // withCredentials: true,
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                let result = JSON.stringify(response.data);
                let data = JSON.parse(result);
                setEventData(data);
                // console.log("Result in data", data);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
            });
        setTriggerEffect(false)
    }, [triggerEffect]);


    // Post API
    const [evntdata, setEvntData] = useState({
        date: "",
        name: "",
        link: "",
        description: ""
    })

    const onChangeEvent = (e) => {
        const { id, value } = e.target
        setEvntData({ ...evntdata, [id]: value })
    }

    const eventSubmit = (e) => {
        e.preventDefault();
        const token = Cookies.get("jwt");
        // console.log('Form Data Submitted:', evntdata);

        let socialData = JSON.stringify({
            "date": evntdata.date,
            "name": evntdata.name,
            "link": evntdata.link,
            "description": evntdata.description
        });

        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/socialmedia`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
            data: socialData,
            withCredentials: true,
        };

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setTriggerEffect(true)
            })
            .catch((error) => {
                console.log(error);
            });
    }
    // Social Media APIs


    // Media Coverage APIs
    const [covtriggerEffect, setCovTriggerEffect] = useState(false)
    // Get API
    const [coverageData, setCoverageData] = useState([])
    useEffect(() => {
        // console.log("token social media", token);
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/mediacoverage`,
            headers: {
                Authorization: token,
            },
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                let result = JSON.stringify(response.data);
                let data = JSON.parse(result);
                setCoverageData(data);
                // console.log("result coverage", data);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
            });

            setCovTriggerEffect(false)

    }, [covtriggerEffect])


    // Post API
    const [putcoverageData, setPutcoverageData] = useState({
        date: "",
        name: "",
        link: "",
    })

    const onChangeCoverage = (e) => {
        const { id, value } = e.target
        setPutcoverageData({ ...putcoverageData, [id]: value })
    }

    const coverageSubmit = (e) => {
        e.preventDefault();
        // console.log('Form Data Submitted putcoverageData:', putcoverageData);

        let covData = JSON.stringify(
            {
                "date": putcoverageData.date,
                "name": putcoverageData.name,
                "link": putcoverageData.link,
                "description": putcoverageData.description,
            }
        )

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/mediacoverage`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,

            },
            data: covData,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setCovTriggerEffect(true)
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <>
            <Breadcrumb data="Social Media" />
            <div className="content-body">
                {/* social media */}
                <div className="table-data">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0">Social Media</h5>
                        <button className="btn btn-warning download-btn" variant="primary"
                            onClick={handleShow}>Add</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Link(URL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eventData && eventData.map((value, index) => {
                                    const isoDateString = value.created_at;
                                    const date = new Date(isoDateString);

                                    const options = {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric',
                                        second: 'numeric',
                                        hour12: true
                                    };

                                    const formattedDateTime = date.toLocaleString(undefined, options);
                                    return (
                                        <tr key={index}>
                                            <td>{formattedDateTime}</td>
                                            <td>{value.description}</td>
                                            <td><Link to={value.link} target="_blank" rel="noopener noreferrer">{value.link}</Link></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* social media */}

                {/* Media Coverage */}
                <div className="table-data">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0">Media Coverage</h5>
                        <button className="btn btn-warning download-btn" variant="primary"
                            onClick={covHandleShow}>Add</button>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Link(URL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coverageData && coverageData.map((value, index) => {
                                        const isoDateString = value.created_at;
                                        const date = new Date(isoDateString);

                                        const options = {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            second: 'numeric',
                                            hour12: true
                                        };

                                        const formattedDateTime = date.toLocaleString(undefined, options);
                                        return (
                                            <tr key={index}>
                                                <td>{formattedDateTime}</td>
                                                <td>{value.description}</td>
                                                <td><Link to={value.link} target="_blank" rel="noopener noreferrer">{value.link}</Link></td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Media Coverage */}
            </div>

            {/* Social Media */}
            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Socical Media</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={eventSubmit}>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Social media platform</th>
                                        <th>Social media link</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                required
                                                type="date"
                                                id="date"
                                                name="date"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="name"
                                                name="name"
                                                placeholder='Enter social media platform'
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="link"
                                                name="link"
                                                placeholder='Paste social media link here'
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="description"
                                                name="description"
                                                placeholder='Enter description'
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <button type="submit" onClick={handleClose} className="download-btn d-flex ms-auto">
                            Save
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
            {/* Social Media */}


            {/* Social Media */}
            <Modal show={covshow} onHide={covHandleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Media Coverage</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={coverageSubmit}>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Media coverage platform</th>
                                        <th>Media coverage link</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                required
                                                type="date"
                                                id="date"
                                                name="date"
                                                onChange={onChangeCoverage}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="name"
                                                name="name"
                                                placeholder='Enter media coverage platform'
                                                onChange={onChangeCoverage}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="link"
                                                name="link"
                                                placeholder='Paste media coverage link here'
                                                onChange={onChangeCoverage}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="description"
                                                name="description"
                                                placeholder='description'
                                                onChange={onChangeCoverage}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <button type="submit" onClick={covHandleClose} className="download-btn d-flex ms-auto">
                            Save
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
            {/* Social Media */}
        </>
    )
}

export default SocialMedia
